// extracted by css-extract-rspack-plugin
export default {"link":"TitleLink_link__GZZ4b"};